import { createContext, useContext } from 'react';
export const DEFAULT_AETHER_LABELS = {
    close: 'Close',
    dismiss: 'Dismiss',
    remove: 'Remove',
    clear: 'Clear',
    cancel: 'Cancel',
    confirm: 'Confirm',
    notifications: 'Notifications',
    logoPerplexity: 'Perplexity',
    logoPerplexityPro: 'Perplexity Pro',
    logoPerplexityMax: 'Perplexity Max',
    logoEnterprise: 'Enterprise',
    logoEnterprisePro: 'Enterprise Pro',
    logoEnterpriseMax: 'Enterprise Max',
    logoEducationPro: 'Education Pro',
    logoFull: 'Perplexity',
    logoMark: 'Perplexity',
    logoComputer: 'Computer',
    logoPerplexityComputer: 'Perplexity Computer',
};
export const AetherLabelsContext = createContext(DEFAULT_AETHER_LABELS);
AetherLabelsContext.displayName = 'AetherLabelsContext';
export function useAetherLabels() {
    return useContext(AetherLabelsContext);
}
//# sourceMappingURL=useAetherLabels.js.map